// pages/ClientesFormWrapper.tsx
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ClientesForm from "./ClientesForm";
import { ClienteData } from "../components/form/FormFields";
import { clienteService } from "../services/entitiesServices";

/**
 * Decide entre criar ou editar cliente.
 * Se estiver em edição, busca o cliente no backend.
 */
export default function ClientesFormWrapper() {
  const { id } = useParams(); // vem como string (UUID)
  const isEditing = Boolean(id);

  const [client, setClient] = useState<ClienteData>({
    nome: "",
    cpf_cnpj: "",
    telefone: "",
    email: "",
  });

  const [isLoading, setIsLoading] = useState(isEditing);

  useEffect(() => {
    if (!isEditing || !id) return;

    const fetchClient = async () => {
      try {
        const response = await clienteService.getById(id);
        const data = response?.data || response;

        setClient({
          id: data.id,
          nome: data.nome ?? "",
          cpf_cnpj: data.cpfCnpj ?? "",
          telefone: data.telefone ?? "",
          email: data.email ?? "",
        });
      } catch (error) {
        console.error("Erro ao carregar cliente:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchClient();
  }, [id, isEditing]);

  const handleSubmit = async (data: ClienteData) => {
    try {
      if (isEditing && id) {
        await clienteService.update(id, data);
      } else {
        await clienteService.create(data);
      }
    } catch (error) {
      console.error("Erro ao salvar cliente:", error);
    }
  };

  return (
    <ClientesForm
      id={isEditing ? id : undefined} // UUID string
      client={client}
      isLoading={isLoading}
      onSubmit={handleSubmit}
    />
  );
}
